import { Environments } from '../../constants/environments';
import { FeatureFlagName, featureFlags } from './featureFlags';
import { getAppEnvironment } from '../environment/runtimeEnv';

export default class FeatureFlagManager {
  public static get<T>(flagName: FeatureFlagName): T {
    return featureFlags[flagName][getAppEnvironment() as Environments] as T;
  }
}
